import { getListingReport } from "api/@teams/dashboard"

export const platformTeamsFetchListingReports = () => {
  return async (dispatch) => {
    const data = await getListingReport()
    if (!data.error) {
      dispatch({
        type: "TEAMS_UPDATE_REPORTS",
        data: {
          ...data,
          templateList: undefined,
          scoreChanger: undefined
        }
      })
      dispatch({
        type: "TEAMS_UPDATE_TEMPLATE_LIST",
        data: data.templateList
      })
      dispatch({
        type: "TEAMS_UPDATE_SCOREUPDATER_LIST",
        data: data.scoreChanger
      })
    }
  }
}

// export const changeActiveTemplate = (data) => {
//   return async (dispatch) => {
//     dispatch({ type: "TEAMS_UPDATE_TEMPLATE_ACTIVE_INDEX", data })
//   }
// }
